import { useAtom } from '@reatom/npm-react'
import { useState } from 'react'
import styled from 'styled-components'

import { languageAtom } from '@root/shared/localization/atoms'
import { currentThemeAtom } from '@root/shared/theme/atoms/current-theme-atom'

import { XTweetEmbed } from './x-tweet-embed'

import type * as KnownSocialPlatformResource from '../model/known-social-platform-resource'

export const SocialXEmbed = ({
  resource,
  onResize,
}: {
  resource: KnownSocialPlatformResource.XKnownSocialPlatformResource
  onResize?: (sizes: { height: number; width: number }) => void
}) => {
  const [currentLang] = useAtom(languageAtom)
  const [currentTheme] = useAtom(currentThemeAtom)
  const [height, setHeight] = useState<string>('300px')

  return (
    <Root $height={height}>
      <XTweetEmbed
        onResize={(sizes) => {
          setHeight('auto')
          onResize?.(sizes)
        }}
        lang={currentLang}
        theme={currentTheme.appearance}
        tweetId={resource.tweetId}
      />
    </Root>
  )
}

const Root = styled.div<{ $height: string }>`
  position: relative;
  width: 350px;
  min-height: ${({ $height }) => $height};
  max-height: var(--viewport-height);

  overflow: auto;

  & .twitter-tweet {
    margin: 0 !important;
  }
`
